import { Tabs, TabsTriggerProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

/*
 * `id` is omitted so a custom one fails tsc: zag finds the focused tab by its
 * generated trigger id (arrow-key navigation) and points each panel's
 * `aria-labelledby` at it, and Ark lets a user `id` replace that id. v2
 * silently overwrote a custom `id`, so it was harmless there.
 */
export interface MTabProps extends Omit<TabsTriggerProps, 'value' | 'id'> {
  /** Injected positionally by the parent `MTabList` — not usually set directly. */
  value?: string;
}

/*
 * `value` is optional here purely so `<MTab>` reads naturally at a bare
 * call site — `MTabList` always supplies the real value via cloning before
 * this ever renders standalone. See `MTabList.tsx`.
 */
export const MTab = forwardRef<HTMLButtonElement, MTabProps>(
  ({ value, ...rest }, ref) => (
    <Tabs.Trigger ref={ref} value={value ?? ''} {...rest} />
  ),
);

MTab.displayName = 'MTab';

export default MTab;
